export const getRegistrationPlatform = () => {
  if (typeof window !== 'undefined' && window.ReactNativeWebView) return 'ANDROID';
  if (typeof window !== 'undefined' && window.Capacitor?.platform === 'android') return 'ANDROID';
  if (/android/i.test(navigator.userAgent)) return 'ANDROID';
  return 'WEBSITE';
};
